import React from 'react';
import { formatUSD, formatSamples } from '../lib/format';

export default function PerLife({ pharmaAnnual, samples, benchmark }) {
  const pricePerPatient = samples > 0 ? Math.round(Number(pharmaAnnual) / Number(samples)) : 0;
  const status = computeStatus(pricePerPatient, benchmark);
  return (
    <div style={containerStyle} data-testid="per-life-card">
      <div style={titleStyle}>Per-Patient Annual Value</div>
      <div style={amountStyle}>{formatUSD(pricePerPatient)}</div>
      <div style={subtitleStyle}>across {formatSamples(samples)} patients</div>
      {benchmark && (
        <div style={{ ...benchmarkStyle, color: status.color }} data-testid="per-life-benchmark">
          <span style={dotStyle(status.color)} aria-hidden="true" />
          <span>
            {status.label}: typical {formatUSD(benchmark.low)}–{formatUSD(benchmark.high)} per patient
          </span>
        </div>
      )}
    </div>
  );
}

function computeStatus(price, benchmark) {
  if (!benchmark) return { label: '', color: 'var(--muted)' };
  if (price < benchmark.low) return { label: 'Below typical range', color: 'var(--amber-strong)' };
  if (price > benchmark.high * 2) return { label: 'Well above typical range', color: 'var(--error)' };
  if (price > benchmark.high) return { label: 'Above typical range', color: 'var(--amber-strong)' };
  return { label: 'Within typical range', color: 'var(--accent)' };
}

const containerStyle = {
  background: 'var(--surface)',
  border: '1px solid var(--line)',
  borderRadius: '12px',
  padding: '24px',
};

const titleStyle = {
  fontSize: '13px',
  fontWeight: 600,
  color: 'var(--ink2)',
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
  marginBottom: '8px',
};

const amountStyle = {
  fontSize: '36px',
  fontWeight: 700,
  color: 'var(--ink)',
  letterSpacing: '-0.02em',
};

const subtitleStyle = {
  fontSize: '14px',
  color: 'var(--muted)',
  marginTop: '4px',
};

const benchmarkStyle = {
  marginTop: '12px',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  fontSize: '13px',
  fontWeight: 500,
};

function dotStyle(color) {
  return {
    width: 8,
    height: 8,
    borderRadius: 4,
    background: color,
    display: 'inline-block',
  };
}
